module.exports = __webpack_public_path__ + "img/P18_20000224-028_7.c3cfcd35.jpg";